
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categorie/[slug]",
      function () {
        return require("private-next-pages/categorie/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/categorie/[slug]"])
      });
    }
  